import { create } from 'zustand'

/**
 * inbox-scroll-store.ts — Tín hiệu "về đầu danh sách hội thoại", kiểu Zalo: bấm lại tab "Nhắn tin" ở thanh
 * điều hướng dưới (components/shared/mobile-tab-bar.tsx) trong lúc ĐANG đứng ở màn danh sách thì cuộn về đầu.
 *
 * `mobile-tab-bar.tsx` và trang Hội thoại (conversations-page.tsx/conversation-list.tsx) là 2 nhánh anh em dưới
 * AppLayout (không truyền prop/ref trực tiếp cho nhau được) — store nhỏ này là kênh giao tiếp chung. Chỉ 1 số
 * đếm, không lưu lại qua phiên (không cần localStorage).
 */
interface InboxScrollState {
  resetSignal: number
  requestReset: () => void
}

export const useInboxScrollStore = create<InboxScrollState>((set, get) => ({
  resetSignal: 0,
  requestReset: () => set({ resetSignal: get().resetSignal + 1 }),
}))
